
import moment from 'moment';
import axios from 'axios';

export default {
    methods: {
        formatDate(d) {
          var dat = moment(d)
          if(dat.isValid()) {
            return moment(d).tz('Asia/Tokyo').format("YYYY年MM月DD日 HH:mm")
          } else {
            return d
          }
        },
        createRecord(data, url, idToken){
          var response_data = {}
          var is_success = true
          axios
          .post(process.env.VUE_APP_API_ENDPOINT + url, {data: data} ,{headers: {'Authorization': 'Bearer ' + idToken}})
          .then(response => {
            response_data = response.data
          }).catch(error => {
            is_success = false
            this.errorNotify(error.response)
          })
          return {'status': is_success, 'data': response_data}
        },
        updateRecord(data, url, idToken){
          var response_data = {}
          var is_success = true
          axios
          .patch(process.env.VUE_APP_API_ENDPOINT + url + data.id, {data: data} ,{headers: {'Authorization': 'Bearer ' + idToken}})
          .then(response => {
            response_data = response.data
          }).catch(error => {
            is_success = false
            this.errorNotify(error.response)
          })
          return {'status': is_success, 'data': response_data}
        },
        deleteRecord(data, url, idToken){
          var response_data = {}
          var is_success = true
          axios
          .delete(process.env.VUE_APP_API_ENDPOINT + url + data.id, {headers: {'Authorization': 'Bearer ' + idToken}})
          .then(response => {
            response_data = response.data
          }).catch(error => {
            is_success = false
            this.errorNotify(error.response)
          })
          return {'status': is_success, 'data': response_data}
        }
    }
}
